"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BpCheckbox = exports.BpIndeterminateIcon = exports.BpCheckedIcon = exports.BpIcon = void 0;
var styles_1 = require("@mui/material/styles");
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var colors_1 = require("../ThemeProvider/colors");
var checkboxSize = 18;
exports.BpIcon = (0, styles_1.styled)('span')(function () { return ({
    borderRadius: '3px',
    width: checkboxSize,
    height: checkboxSize,
    border: "1px solid ".concat(colors_1.tannerGray['600']),
    'input: active ~ &': {
        borderColor: colors_1.tannerSemantic.info.color,
    },
    'input:disabled ~ &': {
        backgroundColor: colors_1.tannerGray['100'],
        borderColor: colors_1.tannerGray['300'],
    },
}); });
exports.BpCheckedIcon = (0, styles_1.styled)(exports.BpIcon)({
    backgroundColor: colors_1.tannerSemantic.info.color,
    borderColor: colors_1.tannerSemantic.info.color,
    '&:before': {
        'input:enabled ~ &': {
            boxShadow: "0px 2px 2px 0px ".concat(colors_1.tannerBlack, "33"), // 20% opacity in hex
        },
        position: 'absolute',
        width: 3,
        height: 12,
        left: '50%',
        top: 'calc(50% - 6px)',
        background: colors_1.tannerWhite,
        borderRadius: '3px',
        transform: 'rotate(45deg)',
        content: '""',
    },
    '&:after': {
        'input:enabled ~ &': {
            boxShadow: "0px 2px 2px 0px ".concat(colors_1.tannerBlack, "33"), // 20% opacity in hex
        },
        position: 'absolute',
        width: 3,
        height: 6,
        left: 'calc(50% - 5px)',
        top: 'calc(50% - 1px)',
        background: colors_1.tannerWhite,
        borderRadius: '3px',
        transform: 'rotate(135deg)',
        content: '""',
    },
    'input: disabled ~ &': {
        backgroundColor: colors_1.tannerSemantic.info.color,
        borderColor: colors_1.tannerSemantic.info.color,
        opacity: '30%',
    },
});
var indeterminateWidth = 10;
var indeterminateHeight = 3;
exports.BpIndeterminateIcon = (0, styles_1.styled)(exports.BpIcon)({
    backgroundColor: colors_1.tannerSemantic.info.color,
    borderColor: colors_1.tannerSemantic.info.color,
    '&:before': {
        'input:enabled ~ &': {
            boxShadow: "0px 2px 2px 0px ".concat(colors_1.tannerBlack, "33"), // 20% opacity in hex
        },
        position: 'absolute',
        width: indeterminateWidth,
        height: indeterminateHeight,
        left: "calc(50% - ".concat(indeterminateWidth, "px / 2)"),
        top: "calc(50% - ".concat(indeterminateHeight, "px / 2)"),
        background: colors_1.tannerWhite,
        borderRadius: '3px',
        content: '""',
    },
    'input:disabled ~ &': {
        backgroundColor: colors_1.tannerSemantic.info.color,
        borderColor: colors_1.tannerSemantic.info.color,
        opacity: '30%',
    },
});
exports.BpCheckbox = (0, styles_1.styled)(Checkbox_1.default)(function (_a) {
    var disableRipple = _a.disableRipple;
    return ({
        width: 36,
        height: 36,
        '&& .MuiTouchRipple-child': {
            backgroundColor: disableRipple
                ? 'transparent'
                : "".concat(colors_1.tannerSemantic.info.color, "4d"), // 30% opacity in hex
        },
        ':hover': {
            backgroundColor: disableRipple
                ? 'transparent'
                : "".concat(colors_1.tannerSemantic.info['200'], "4d"),
            transition: disableRipple ? 'none' : 'background-color 300ms ease-out',
        },
        ':not(:hover)': {
            transition: disableRipple ? 'none' : 'background-color 300ms ease-out',
        },
        '&.Mui-focusVisible': {
            outlineOffset: '3px',
            outline: "3px solid  ".concat(colors_1.tannerSemantic.info.color),
            borderRadius: '3px',
        },
    });
});
//# sourceMappingURL=styles.js.map